import React, { Fragment } from "react";
import {
  SidebarHeader,
  SidebarViewAll,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../layouts/layout1";
import Title from "../title/title";
import Tag from "../tag/tag";
import Heading from "../heading/heading";
import SectionStart from "../sectionStart/sectionStart";
import ApiDocumentationCards from "../apiDocumentationCards/apiDocumentationCards";

// The API links of a product that has no Advantages section (no advantages, no changelog),
// which is where they are shown otherwise - e.g. the admin-only "For Review" product.
const ApiProductApis = ({ apis }) => (
  <SectionStart>
    <div className="nbg-hub-apis-product">
      <SideBar>
        <SidebarLeft>
          <Fragment>
            <SidebarHeader>
              <Title type="small">
                <Tag className="display-effect">DOCUMENTATION</Tag>
              </Title>
              <Title type="section">
                <Heading level="1" className="display-effect">
                  APIs
                </Heading>
              </Title>
            </SidebarHeader>
            <SidebarViewAll />
          </Fragment>
        </SidebarLeft>
        <SidebarRight>
          <ApiDocumentationCards apis={apis} />
        </SidebarRight>
      </SideBar>
    </div>
  </SectionStart>
);

export default ApiProductApis;
